import { Component, inject, OnInit } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { lastValueFrom } from 'rxjs';

import { OnboardingProvider } from 'src/providers/onboarding/onboarding.provider';
import { Client } from 'src/providers/client/client';

import { ConciergeApiService } from 'src/shared/services/concierge-api.service';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { Util } from 'src/shared/util/util';
import { OnboardingComponent } from 'src/shared/components/onboarding/onboarding';

@Component({
    selector: 'create-concierge-rules-onboarding',
    templateUrl: './create-concierge-rules-onboarding.html',
    styleUrls: ['./create-concierge-rules-onboarding.scss'],
    standalone: false
})

export class CreateConciergeRulesOnboarding implements OnInit {

  popularRules = [
    'Notify the account owner immediately via [Preferred Method, e.g., TIDY message, text message] if any damage occurs or if a significant issue is discovered.',
    'Before and after photos are required for every completed job and must be uploaded to the job record.',
    'If available, assign [Specific Pro Name/ID] to all scheduled jobs for this property/account. If unavailable, notify me before assigning someone else.',
    'For short-term rental properties, prioritize completing cleaning jobs as early as possible on days with same-day guest check-outs and check-ins.',
    'New service providers assigned to this account must first complete and submit [Specific Document, e.g., W-9 Form, Vendor Intake Form] before starting their first job.'
  ];
  form: UntypedFormGroup;
  forms: FormArray;
  submitted = false;

  boundSaveRule = this.saveRule.bind(this);

  readonly onboardingProvider = inject(OnboardingProvider);
  private readonly client = inject(Client);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly util = inject(Util);
  private readonly conciergeApi = inject(ConciergeApiService);
  private readonly rightSidePanelService = inject(RightSidePanelService);
  public readonly windowService = inject(WindowService);

  constructor() {
    this.forms = this.fb.array([]);
    this.forms.push(
      this.fb.group({
        rule: ['', Validators.required],
      })
    );
  }

  ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Create Rules');
  }

  addRule(rule = null) {
    if (this.forms.controls.length === 1 && this.forms.controls[0].value.rule === '') {
      this.forms.controls[0].patchValue({
        rule
      });
    } else {
      this.forms.push(
        this.fb.group({
          rule: [rule || '', Validators.required],
        })
      );
    }
  }

  removeRule(index: number) {
    this.forms.removeAt(index);
  }

  async saveRule() {
    this.submitted = true;
    if (this.forms.invalid) {
      return this.util.showWarning('Please fill out all fields');
    }
    try {
      await Promise.all([
        ...this.forms.controls.map(async (form) => {
          const payload = {
            description: form.value.rule,
          };
          await lastValueFrom(this.conciergeApi.addRule(payload));
        }),
        this.onboardingProvider.markGoalAsCompleted('createConciergeRules')
      ]);
      this.rightSidePanelService.setDialogPageTitle('Getting Started');
      this.rightSidePanelService.navigateTo('onboarding', {}, OnboardingComponent);
      this.onboardingProvider.setShowOnboardingInDashboard(true);
      this.onboardingProvider.setShowOnboardingInHeader(true);
      this.util.showSuccess('Rules saved succesfully');
    } catch (err) {
      this.util.showError(err?.error?.message ? err.error.message : err.message);
    }
  }

} 